// Copyright 2022 - 2023 Fewcha. All rights reserved.

import { configureStore } from "@reduxjs/toolkit";
import configReducer from "features/config/configReducer";
import eventReducer from "features/event/eventReducer";
import statsReducer from "features/stats/statsReducer";
import themeReducer from "features/theme/themeReducer";
import tokensReducer from "features/tokens/tokensReducer";
import walletReducer from "features/wallet/walletReducer";
import { firebaseReducer } from "react-redux-firebase";

const createStore = () => {
  return configureStore({
    reducer: {
      firebase: firebaseReducer,
      wallet: walletReducer,
      event: eventReducer,
      stats: statsReducer,
      theme: themeReducer,
      config: configReducer,
      tokens: tokensReducer,
    },
  });
};

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export let store = createStore();

export const selectFirebase = (state: RootState) => state.firebase;
